import { Button, Space, Typography } from 'antd';
import { UserRoles } from 'common/enums';
import HelpPopover from 'components/help';
import React from 'react';
import { useSelector } from 'react-redux';
import CLassroomIcon from "../../../assets/images/icons/teacher_classes.svg";
import './Header.css';

const { Title } = Typography;

interface HeaderProps {
  data: any;
  className: string;
  onReserve?: () => void;
  onAddAvailability?: () => void;
  onAddPublication?: () => void;
  onAddCourse?: () => void;
}

const ClassroomHeader: React.FC<HeaderProps> = ({ data, className, onReserve, onAddAvailability, onAddPublication, onAddCourse }) => {

  const { user } = useSelector((state) => state.auth);

  return (
    <div className="header-container">
      <Space align="center" size="middle">
        <div className="icon-wrapper">
          <img src={CLassroomIcon} height={30} />
        </div>
        <Title level={4} style={{ margin: 0 }}>
          {className}
        </Title>
        <HelpPopover id={"classe"} />
      </Space>

      {data?.status === "PUBLISHED" && data?.teacher && user?.roles?.includes(UserRoles?.ORGANISME) && <Button
        type="primary"
        size="middle"
        onClick={onReserve}
        className="classBtn classBtn-teal"
      >
        Réserver un cours
      </Button>}

      {user?.roles?.includes(UserRoles?.TEACHER) && data?.status === "PUBLISHED" && data?.organism && <div className="buttons-row">
        <Button
          type="primary"
          size="middle"
          onClick={onAddAvailability}
          className="classBtn classBtn-green"
        >
          + Ajouter un créneau
        </Button>
        <Button
          type="primary"
          size="middle"
          onClick={onAddPublication}
          className="classBtn classBtn-teal"
        >
          + Ajouter une publication
        </Button>
      </div>}

      {user?.roles?.includes(UserRoles?.TEACHER) && data?.status === "PUBLISHED" && !data?.organism && <div className="buttons-row">
        <Button
          type="primary"
          size="middle"
          onClick={onAddCourse}
          className="classBtn classBtn-green"
        >
          + Créer un cours
        </Button>
        <Button
          type="primary"
          size="middle"
          onClick={onAddPublication}
          className="classBtn classBtn-teal"
        >
          + Ajouter une publication
        </Button>
      </div>}
    </div>
  );
};

export default ClassroomHeader;
